var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 64,
    viewBox: "0 0 54 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6281 38.9659H18.3719C12.7017 38.9659 8.08862 34.3529 8.08862 28.6826V17.9073C8.08862 12.2371 12.7016 7.62402 18.3719 7.62402H35.6281C41.2982 7.62402 45.9114 12.237 45.9114 17.9073V28.6826C45.9112 34.3529 41.2982 38.9659 35.6281 38.9659ZM18.3719 10.3741C14.2181 10.3741 10.8386 13.7535 10.8386 17.9074V28.6828C10.8386 32.8365 14.218 36.216 18.3719 36.216H35.6281C39.7819 36.216 43.1614 32.8366 43.1614 28.6828V17.9074C43.1614 13.7535 39.782 10.3741 35.6281 10.3741H18.3719Z",
    fill: "#00E378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1877 30.1924C22.9504 30.1924 22.713 30.131 22.5002 30.0082C22.0749 29.7625 21.8127 29.3085 21.8127 28.8174V17.8124C21.8127 17.3212 22.0749 16.8672 22.5002 16.6217C22.9257 16.376 23.45 16.3762 23.8752 16.6217L33.4059 22.1242C33.8312 22.3698 34.0934 22.8237 34.0934 23.3149C34.0934 23.8062 33.8312 24.26 33.4059 24.5057L23.8752 30.0082C23.6625 30.131 23.4251 30.1924 23.1877 30.1924ZM24.5627 20.194V26.4359L29.9684 23.3149L24.5627 20.194Z",
    fill: "#F1F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1609 64H1.83936C1.07998 64 0.464355 63.3844 0.464355 62.625V1.375C0.464355 0.615625 1.07998 0 1.83936 0H52.1609C52.9202 0 53.5359 0.615625 53.5359 1.375V62.625C53.5359 63.3844 52.9202 64 52.1609 64ZM3.21435 61.25H50.7859V2.75H3.21435V61.25Z",
    fill: "#F1F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9119 46.5908H17.0884C16.329 46.5908 15.7134 45.9752 15.7134 45.2158C15.7134 44.4564 16.329 43.8408 17.0884 43.8408H36.912C37.6714 43.8408 38.287 44.4564 38.287 45.2158C38.2869 45.9752 37.6714 46.5908 36.9119 46.5908Z",
    fill: "#F1F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7185 54.0879H21.2817C20.5224 54.0879 19.9067 53.4723 19.9067 52.7129C19.9067 51.9535 20.5224 51.3379 21.2817 51.3379H32.7185C33.4779 51.3379 34.0935 51.9535 34.0935 52.7129C34.0935 53.4723 33.4779 54.0879 32.7185 54.0879Z",
    fill: "#00E378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.d2262fb6caf8f0e4313a04136a1eb4f5.svg";
export { ForwardRef as ReactComponent };